var _g, _path, _path2, _g2, _path3, _path4, _path5, _g3, _path6, _path7, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 60,
    viewBox: "0 0 136 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_846_5186)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 128,
    height: 43,
    rx: 5,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_846_5186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 20,
    width: 116,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1851 20.0014H125.835V39.6251H10.1851V20.0014Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_846_5186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_846_5186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 20,
    width: 116,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1851 39.6251H125.835V20.0014H10.1851V39.6251Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_846_5186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5369 22.1492C55.5369 21.6831 55.722 21.2361 56.0516 20.9065C56.3812 20.5769 56.8282 20.3918 57.2943 20.3918C57.7604 20.3918 58.2073 20.5769 58.5369 20.9065C58.8665 21.2361 59.0516 21.6831 59.0516 22.1492C59.0347 22.6039 58.8421 23.0343 58.5144 23.3501C58.1866 23.6658 57.7493 23.8422 57.2943 23.8422C56.8392 23.8422 56.4019 23.6658 56.0741 23.3501C55.7464 23.0343 55.5538 22.6039 55.5369 22.1492Z",
    fill: "#273B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2646 33.8696C83.2646 32.8942 84.0503 32.1073 85.0183 32.1073C85.3672 32.1056 85.7088 32.2075 85.9997 32.4001C86.2906 32.5927 86.5178 32.8674 86.6525 33.1892C86.7872 33.5111 86.8234 33.8657 86.7564 34.2081C86.6893 34.5505 86.5222 34.8653 86.2761 35.1126C86.0299 35.36 85.716 35.5286 85.3739 35.5973C85.0318 35.666 84.677 35.6316 84.3545 35.4985C84.032 35.3654 83.7563 35.1395 83.5622 34.8495C83.3682 34.5595 83.2647 34.2185 83.2646 33.8696Z",
    fill: "#499FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7064 33.1072C25.1938 33.1072 24.1413 31.9054 24.1413 30.1872C24.1413 28.4689 25.1938 27.2696 26.7076 27.2696C28.2288 27.2696 29.2923 28.4689 29.2923 30.1872C29.2923 31.9323 28.2521 33.1072 26.7064 33.1072ZM26.7064 24.7033C23.5049 24.7033 21.1809 27.0102 21.1809 30.1859C21.1809 33.3617 23.5062 35.6686 26.7064 35.6686C29.9213 35.6686 32.2539 33.3629 32.2539 30.1859C32.2539 27.0089 29.9213 24.7008 26.7076 24.7008M52.1445 30.4601C52.033 30.2446 51.8921 30.0456 51.7259 29.869L51.628 29.7674L51.7308 29.6695C51.8923 29.4981 52.0396 29.3139 52.1713 29.1188L54.9861 24.9187H51.5546L49.4312 28.2046C49.3113 28.3808 49.069 28.4689 48.7056 28.4689H48.2221V22.2569C48.2221 21.0147 47.4475 20.8458 46.6116 20.8458H45.1797L45.1835 35.507H48.2233V31.1087H48.5085C48.8549 31.1087 49.0899 31.1491 49.1988 31.3375L50.8754 34.5023C51.3441 35.3614 51.8104 35.5058 52.6891 35.5058H55.0179L53.2826 32.6372L52.1322 30.4588M66.8876 24.6751C65.3408 24.6751 64.3543 25.3629 63.8012 25.9442L63.6176 26.1302L63.5515 25.8769C63.39 25.2528 62.8417 24.9125 62.0181 24.9125H60.656L60.6646 35.5021H63.6837V30.6216C63.6837 30.1443 63.7449 29.7307 63.8722 29.3525C64.2075 28.2083 65.145 27.4972 66.3162 27.4972C67.2585 27.4972 67.6256 27.9953 67.6256 29.2803V33.8941C67.6256 34.9906 68.1335 35.5034 69.2312 35.5034H70.668L70.6631 28.7675C70.6631 26.0923 69.3572 24.6776 66.8864 24.6776M57.3407 24.9174H55.9089L55.9187 35.507H57.4448L57.4986 35.5095L58.2108 35.507H58.9182V35.5034H58.9231L58.9292 26.5267C58.9292 25.4437 58.4115 24.9174 57.3407 24.9174ZM38.5614 33.1059C37.0488 33.1059 35.9951 31.9042 35.9951 30.1859C35.9951 28.4677 37.0476 27.2684 38.5626 27.2684C40.0777 27.2684 41.1473 28.4677 41.1473 30.1859C41.1473 31.9311 40.1059 33.1059 38.5614 33.1059ZM38.5614 24.7021C35.3575 24.7021 33.0323 27.0089 33.0323 30.1847C33.0323 33.3605 35.3575 35.6674 38.5639 35.6674C41.7703 35.6674 44.1114 33.3617 44.1114 30.1847C44.1114 27.0077 41.7862 24.6996 38.5639 24.6996",
    fill: "#273B7D"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_846_5186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 20,
    width: 116,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1851 20.0014H125.835V39.6251H10.1851V20.0014Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_846_5186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_846_5186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 20,
    width: 116,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1851 20.3881H125.81V39.5994H10.1851V20.3881Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_846_5186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_846_5186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 20,
    width: 116,
    height: 20
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1851 39.6251H125.835V20.0014H10.1851V39.6251Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_846_5186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.262 33.1072C101.749 33.1072 100.694 31.9054 100.694 30.1872C100.694 28.4689 101.749 27.2696 103.262 27.2696C104.782 27.2696 105.847 28.4689 105.847 30.1872C105.847 31.9323 104.807 33.1072 103.262 33.1072ZM103.262 24.7033C100.058 24.7033 97.7336 27.0102 97.7336 30.1859C97.7336 33.3617 100.059 35.6686 103.262 35.6686C106.473 35.6686 108.809 33.3629 108.809 30.1859C108.809 27.0089 106.484 24.7008 103.262 24.7008",
    fill: "#499FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0317 32.6409C75.3796 32.6409 74.7922 31.2017 74.7922 29.8506C74.7922 29.2558 74.9427 27.3173 76.8726 27.3173C77.8309 27.3173 79.1073 27.5914 79.1073 29.9485C79.1073 32.1721 77.9777 32.6384 77.0305 32.6384L77.0317 32.6409ZM80.6762 24.8917C80.1035 24.8917 79.6629 25.1206 79.4524 25.5379L79.3692 25.6994L79.2297 25.5771C78.7426 25.1561 77.8688 24.6555 76.4517 24.6555C73.6283 24.6555 71.7278 26.7764 71.7278 29.9301C71.7278 33.0839 73.6944 35.2855 76.5079 35.2855C77.4686 35.2855 78.2286 35.0603 78.8307 34.6051L79.0755 34.4301V34.7238C79.0755 36.1385 78.1613 36.9193 76.503 36.9193C75.8095 36.911 75.1225 36.7843 74.4716 36.5448C73.8327 36.3514 73.4558 36.5118 73.1988 37.1543L72.9589 37.7466L72.6199 38.613L72.828 38.7232C73.8902 39.2861 75.2719 39.6227 76.5202 39.6227C79.0901 39.6227 82.0934 38.3071 82.0934 34.6051L82.1056 24.8917H80.6762Z",
    fill: "#273B7D"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_846_5186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 20,
    width: 116,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1851 20.0014H125.835V39.6251H10.1851V20.0014Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_846_5186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_846_5186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 20,
    width: 116,
    height: 20
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1851 39.6251H125.835V20.0014H10.1851V39.6251Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_846_5186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4536 32.9859L12.9962 32.9835V30.0463C12.9962 29.4173 13.2409 29.0918 13.777 29.0159H15.4536C16.6492 29.0159 17.4117 29.7698 17.4117 30.9899C17.4105 32.2431 16.6566 32.9847 15.4536 32.9847V32.9859ZM12.9962 25.0606V24.2871C12.9962 23.6103 13.2825 23.2885 13.9104 23.2469H15.1684C16.2454 23.2469 16.8817 23.8918 16.8817 24.9724C16.8817 25.7948 16.4387 26.7555 15.1965 26.7555H12.9852L12.9962 25.0606ZM18.5914 27.9928L18.1471 27.7431L18.5351 27.4127C18.9879 27.0248 19.7418 26.1522 19.7418 24.6469C19.7418 22.3413 17.955 20.8531 15.1892 20.8531H11.672C11.2763 20.8675 10.9012 21.0337 10.6246 21.3171C10.348 21.6005 10.191 21.9795 10.1863 22.3755V35.458H15.2529C18.3283 35.458 20.3133 33.7838 20.3133 31.1906C20.3133 29.7955 19.672 28.601 18.5938 27.994",
    fill: "#273B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.294 24.7154C121.671 24.7177 121.056 24.86 120.495 25.1318C119.935 25.4036 119.442 25.7979 119.054 26.2856L118.836 26.5622L118.665 26.2525C118.104 25.2331 117.142 24.7154 115.805 24.7154C114.401 24.7154 113.46 25.4987 113.023 25.9637L112.736 26.2733L112.614 25.8658C112.455 25.2784 111.932 24.9565 111.142 24.9565H109.873L109.861 35.5057H112.743V30.8492C112.744 30.4333 112.796 30.0192 112.896 29.6156C113.171 28.4897 113.927 27.2781 115.199 27.4005C115.982 27.4763 116.366 28.0821 116.366 29.2521V35.5057H119.269V30.8492C119.258 30.4187 119.313 29.9891 119.432 29.5752C119.677 28.5007 120.455 27.3992 121.681 27.3992C122.57 27.3992 122.898 27.901 122.898 29.2521V33.9637C122.898 35.0285 123.373 35.5057 124.44 35.5057H125.796L125.798 28.7711C125.798 26.0788 124.614 24.7154 122.283 24.7154M96.0523 31.8429C96.0437 31.8551 94.804 33.1609 93.1703 33.1609C91.6821 33.1609 90.1792 32.248 90.1792 30.2116C90.1792 28.4517 91.3444 27.2218 93.0136 27.2218C93.5546 27.2218 94.1713 27.4152 94.268 27.7419L94.2802 27.797C94.3419 28.0219 94.4761 28.2203 94.6619 28.3612C94.8478 28.5022 95.075 28.5778 95.3083 28.5766L96.8992 28.579V27.1985C96.8992 25.3775 94.5825 24.7167 93.0246 24.7167C89.691 24.7167 87.2727 27.037 87.2727 30.2336C87.2727 33.4302 89.6641 35.7456 92.9634 35.7456C95.8247 35.7456 97.3691 33.8646 97.3961 33.8463L97.4793 33.7435L96.2285 31.6691L96.0633 31.8441",
    fill: "#499FDD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_846_5186",
    x: 0,
    y: 7,
    width: 136,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.464167 0 0 0 0 0.778862 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_846_5186"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_846_5186",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.6ae6b30a9180bfc7e24ec752fd6569be.svg";
export { ForwardRef as ReactComponent };